import DapDSTableRow from './table-row.component'

export * from './table-row.component'
export default DapDSTableRow

DapDSTableRow.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-table-row': DapDSTableRow
  }
}
